









import Vue from "vue";
import { Project_project } from "@/api-types";

export default Vue.extend({
  name: "Home",
  props: { project: Object as () => Project_project },
  watch: {
    project: function() {
      this.setTitles();
    }
  },
  methods: {
    setTitles() {
      document.title = `Hydromapper - Projekt '${this.project.name}'`;
      this.$store.commit("setToolbarTitle", `${this.project.name}: Start`);
    }
  },
  mounted() {
    this.setTitles();
  }
});
